var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtomicForceMicroscope128(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.58,108.1v1.69m-11.42-1.69v1.69m-11.43-1.69v1.69M163,97v1.69M151.53,97v1.69M140.1,97v1.69M128.67,97v1.69M163,119.53v1.69m-11.43-1.69v1.69m-11.43-1.69v1.69m-11.43-1.69v1.69M145,138.08v14M60.7,123.63H51.39V55.46H60.7ZM68,137H44.11V123.57H68ZM55.76,55.46v-18H92.05V164.39h13.58m71.7-26.64H114.67V80.87h62.66ZM184,176H108V152.79H184ZM78.24,176H33.84V137h44.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomicForceMicroscope128);
export default __webpack_public_path__ + "static/media/ATOMIC_FORCE_MICROSCOPE_128.ad520abf3ec5417c8d9467b6ba2073b4.svg";
export { ForwardRef as ReactComponent };